import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';

var NavTabs = function NavTabs(_ref) {
  var activeTab = _ref.activeTab,
      tabs = _ref.tabs,
      _onSelect = _ref.onSelect;
  /***
   * DOM
   */

  return /*#__PURE__*/React.createElement(Tabs, {
    activeKey: activeTab.routeKey,
    id: 'tabsID',
    onSelect: function onSelect(eventKey) {
      return eventKey && _onSelect(eventKey);
    }
  }, tabs.map(function (_ref2) {
    var disabled = _ref2.disabled,
        title = _ref2.title,
        routeKey = _ref2.routeKey;
    return /*#__PURE__*/React.createElement(Tab, {
      key: title,
      eventKey: routeKey,
      title: title,
      disabled: disabled
    });
  }));
};

NavTabs.displayName = "NavTabs";
export { NavTabs };